module.exports = __webpack_public_path__ + "img/example_print_slip.8e172ca9.png";